import dataService from "../../api";
import { startLoading, stopLoading,showNotification, serverErrorMessage, showAlert, catchHandler } from "@/utils/helpers";


export default {
    namespaced: true,
    state: {
        employees: [ ],
        employee: {
        },
        totalItems: 0,
    },
    getters: {
        index: state => (id) => state.employees.findIndex(i => i.id === id)
    },
    mutations: {
        SET_ITEMS: (state, data) => state.employees = data,
        SET_TOTAL_ITEMS: (state, r) => (state.totalItems = r),
        SET_ITEM: (state, viewData) => state.employee = viewData,
        add: (state, addedData) => state.employees.unshift(addedData),
        edit: (state, { index, r }) => state.employees.splice(index, 1, r),
        delete: (state, index) => state.employees.splice(index, 1),
    },
    actions: {
        async getAll({ commit }, params) {
            startLoading()
            try {
                const paramsString = Object.entries(params)
                    .filter(([, val]) => val !== null)
                    .map(([key, val]) => `${key}=${val}`)
                    .join("&");

                    const response = await dataService.employees.getAll(paramsString);
                    stopLoading()
                    if (!response.data.statusCode) {
                        showAlert(serverErrorMessage);
                        return;
                    }
        
                commit('SET_ITEMS', response.data.employees);
                commit('SET_TOTAL_ITEMS', response.data.totalItems);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
      
    async getDetails({ commit }, id) {
        try {
            commit("SET_ITEM", {});
            startLoading()
            const response = await dataService.employees.getDetails(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }
            commit("SET_ITEM", response.data.employee);
        
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async add({ commit }, payload) {
        try {
            startLoading()
            const response = await dataService.employees.add(payload);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);
            commit("add", response.data.employee);


        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
  
    async getForEdit(_, id) {
        try {
            startLoading()
            const response = await dataService.employees.getForEdit(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            return Promise.resolve(response.data.employee);
        
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async edit({ commit, getters }, { id, payload }) {
        try {
            startLoading()
            const response = await dataService.employees.edit(id,payload);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }
          
            const index = getters.index(id);
            commit("edit", { index, r: response.data.employee });

        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async delete({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.employees.delete(id);

            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);
            const index = getters.index(id);
            commit("delete", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    },
};
